import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgress } from '@material-ui/core';

export default function Loading(props) {
  const {
    align, padding, className, size,
  } = props;
  return (
    <div
      className={className}
      style={{
        textAlign: align,
        padding,
      }}
    >
      <CircularProgress size={size} />
    </div>
  );
}
Loading.defaultProps = {
  align: 'center',
  className: null,
  padding: '20px',
  size: 50,
};
Loading.propTypes = {
  padding: PropTypes.string,
  align: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};



// WEBPACK FOOTER //
// ./src/layout/Loading.jsx